import React from "react";
import { Button, List, message } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import '../styles/upload.css';


interface ViewUploadProps {
    fileList: any;
}

const ViewUpload: React.FC<ViewUploadProps> = ({ fileList }) => {

    const handleView = (s3Url: string) => {
        if (s3Url) {
            window.open(s3Url, '_blank');
        } else {
            message.error('No URL found for this file.');
        }
    };

    return (
        <div className="viewUploadContainer">
            <h3>View Uploaded Documents</h3>
            <List
                bordered
                dataSource={fileList}
                renderItem={(file:any) => (
                    <List.Item
                        actions={[
                            <Button
                                type="text"
                                icon={<EyeOutlined />}
                                onClick={() => handleView(file.s3Url)}
                            >
                                View
                            </Button>
                        ]}
                    >
                        {file?.name}
                    </List.Item>
                )}
            />
        </div>
    );
};

export default ViewUpload;